import Vue from "vue";
// import VeeValidate from 'vee-validate';
import VeeValidate from "vee-validate";

// Register it globally
// main.js or any entry file.
// Vue.component("ValidationProvider", ValidationProvider);

// Vue.use(VeeValidate, { inject: false });
// Vue.component("ValidationProvider", VeeValidate.ValidationProvider);
// Vue.component("ValidationObserver", VeeValidate.ValidationObserver);

Vue.use(VeeValidate);
